/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_TitleInputs */

const cs_property_registry_title = /** @type {(inputs: Property_Registry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontroly registrů`)
};

const en_property_registry_title = /** @type {(inputs: Property_Registry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registry checks`)
};

/**
* | output |
* | --- |
* | "Registry checks" |
*
* @param {Property_Registry_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_title = /** @type {((inputs?: Property_Registry_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_title(inputs)
	return cs_property_registry_title(inputs)
});